import { User } from '../interfaces/User/User';

export const isUserInternal = (user: User) => user.roleLevel <= 2;
